<template>
    <div class="page">
        <!-- Header -->
        <header class="hero">
            <div class="container text-center">
                <h1> Care-Giver Support Event</h1>
                <p>
                    This event is for training and supporting Care-Givers (Housekeepers, Nannies, and Elderly Carers).
                    It will help you learn useful skills and prepare for better care jobs in 2026.
                </p>
            </div>
        </header>

        <!-- Image -->
        <section class="image-section">
            <div class="container">
                <img src="@/assets/succour-care-background.webp"
                    alt="Caregiver community support" />
            </div>
        </section>

        <!-- Options -->
        <main class="content">
            <div class="container">
                <h2 class="section-title">You can register yourself or help another Care-Giver register.</h2>

                <div class="options">
                    <!-- Register Myself -->
                    <button class="card" @click="registerMyself">
                        <div class="icon-circle">
                            <svg viewBox="0 0 24 24">
                                <circle cx="12" cy="8" r="5" />
                                <path d="M20 21a8 8 0 0 0-16 0" />
                            </svg>
                        </div>
                        <h3>Register Myself</h3>
                        <p>Sign up for the event as a caregiver participant</p>
                    </button>

                    <!-- Register Someone Else -->
                    <button class="card" @click="registerBehalf">
                        <div class="icon-circle">
                            <svg viewBox="0 0 24 24">
                                <circle cx="9" cy="7" r="4" />
                                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                            </svg>
                        </div>
                        <h3>Register Someone Else</h3>
                        <p>Help another caregiver join the event</p>
                    </button>
                </div>
            </div>
        </main>

        <!-- Footer -->
        <footer class="footer">
            <div class="container text-center">
                <p class="muted">Need help with registration?</p>
                <p class="contact">
                    Contact us: support@succour.care | +234 916 000 2370
                </p>
            </div>
        </footer>
    </div>
</template>

<script>
export default {
    name: "LandingPage",
    methods: {
        registerMyself() {
            // route or action
            console.log("Register myself");
            this.$router.push({ name: "SelfRegistration" });
        },
        registerBehalf() {
            // route or action
            console.log("Register on behalf");
            this.$router.push({ name: "BehalfRegistration" });
        },
    },
};
</script>

<style scoped>
/* Base */
.page {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    background: #f8f9fa;
    color: #212529;
    font-family: system-ui, -apple-system, sans-serif;
}

.container {
    max-width: 900px;
    margin: auto;
    padding: 0 16px;
}

.text-center {
    text-align: center;
}

/* Hero */
.hero {
    background: #f59cab;
    color: white;
    padding: 64px 0;
}

.hero h1 {
    font-size: 2.2rem;
    margin-bottom: 16px;
}

.hero p {
    max-width: 650px;
    margin: auto;
    opacity: 0.9;
}

/* Image */
.image-section img {
    width: 100%;
    height: 400px;
    object-fit: cover;
}

/* Content */
.content {
    flex: 1;
    padding: 48px 0;
}

.section-title {
    text-align: center;
    margin-bottom: 32px;
}

/* Cards */
.options {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 24px;
    max-width: 600px;
    margin: auto;
}

.card {
    background: white;
    border-radius: 16px;
    padding: 32px 25px;
    border: 2px solid transparent;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
}

.card:hover {
    border-color: #f59cab;
    box-shadow: 0 14px 32px rgba(0, 0, 0, 0.12);
}

.card h3 {
    margin-bottom: 8px;
}

.card p {
    font-size: 0.9rem;
    color: #6c757d;
}

/* Icon */
.icon-circle {
    width: 80px;
    height: 80px;
    margin: 0 auto 16px;
    background: #f59cab;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.3s ease;
}

.card:hover .icon-circle {
    background: #f8afbb;
}

.icon-circle svg {
    width: 36px;
    height: 36px;
    fill: none;
    stroke: #ffffff;
    stroke-width: 2;
}

/* Footer */
.footer {
    background: white;
    border-top: 1px solid #ced4da;
    padding: 24px 0;
}

.muted {
    color: #6c757d;
    font-size: 0.9rem;
    margin-bottom: 8px;
}

.contact {
    color: #f59cab;
    font-weight: 500;
}

/* Responsive */
@media (max-width: 768px) {
    .hero h1 {
        font-size: 1.8rem;
    }

    .image-section img {
        height: 200px;
    }
}
</style>
